import { rootStoreManager } from 'stores/mobx/Root'

export const openPcapDownloadDialog = (initialQuery = '') => {
  rootStoreManager.dispatchAction('openPcapDownloadDialog', initialQuery)
}
